import { ArpMediaType } from '@arpeggi/shared'
import { ComponentProps, FC } from 'react'
import { styled } from '../../lib/stitches'
import { gray1 } from '../platform/color'
import { useRemix } from '../platform/explore/common/utils'
import { segmentTrackRemix } from './Utils'

const StyledStudioButton = styled('button', {
  all: 'unset',
  width: '70px',
  height: '24px',
  boxSizing: 'border-box',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderColor: '$gray03',
  borderRadius: '9999px',
  borderStyle: 'solid',
  borderWidth: '1px',
  fontSize: '12px',
  lineHeight: '20px',
  fontWeight: '$medium',
  color: '$gray14',
  boxShadow: '0px 1px 2px 0px #0000000D',
  transition: 'all 100ms ease',
  '&:hover': {
    transform: 'translateY(-1px)',
    borderColor: '$gray10'
  },
  '&:active': {
    transform: 'translateY(1px)',
    borderColor: '$gray14'
  },
  '&:disabled': {
    borderColor: '$gray03',
    color: '$gray05'
  },
  variants: {
    large: {
      true: {
        width: '130px',
        height: '40px',
        padding: '16px 12px',
        borderRadius: '10px',
        fontSize: '14px',
        lineHeight: '16px'
      }
    },
    purple: {
      true: {
        backgroundColor: '#675AF8',
        border: 'none',
        color: gray1,
        '&:disabled': {
          backgroundColor: '$gray05'
        }
      }
    }
  }
})

type StudioButtonProps = ComponentProps<typeof StyledStudioButton> & {
  index: number
  mediaType: ArpMediaType
  text?: string
  location?: string
}

const OpenStudioButton: FC<StudioButtonProps> = ({
  index,
  mediaType,
  onClick,
  location,
  ...props
}) => {
  const { remixSong, remixStem, remixSample, status } = useRemix()
  const handleClick = (evt) => {
    evt.stopPropagation()
    segmentTrackRemix(mediaType, index, location || `N/A`)
    if (mediaType === ArpMediaType.SONG) remixSong(index)
    if (mediaType === ArpMediaType.SAMPLE) remixSample(index)
    if (mediaType === ArpMediaType.STEM) remixStem(index)
  }
  return (
    <StyledStudioButton
      onClick={handleClick}
      disabled={status === 'loading' || props.disabled}
      {...props}
    >
      {props.text || `+ Studio`}
    </StyledStudioButton>
  )
}

export default OpenStudioButton
